import React, { useEffect, useState } from "react";
import { TextField, Button } from "@mui/material";

import InternRequestTable from "../../Components/InternRequestTable";
import { matchOptions } from "../../utils/function";
import { optionsBranch } from "../../data/branch-data";
import { Box, Container } from "@mui/material";

import { internType } from "../../data/interntype-data";

import useMediaQuery from '@material-ui/core/useMediaQuery';
import InternEvaluationTable from "../../Components/InternEvaluationTable";
import { start } from "@popperjs/core";
import { current } from "@reduxjs/toolkit";
import { IconButton, Tooltip } from "@mui/material";
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import Typography from "@mui/material/Typography";



const DashboardInternshipTab = ({ items = [], allStaff = [], textActive, onRefresh }) => {

  const defaultPercentages = {
    intern_location: 5,
    logbook: 5,
    assessment_visit: 40,
    assessment_present: 20,
    assessment_supervisor: 30
  };

  const [percentages, setPercentages] = useState(defaultPercentages);

  const handlePercentageChange = (event) => {
    setPercentages({
      ...percentages,
      [event.target.name]: event.target.value
    });
  };

  const handleResetPercentages = () => {
    setPercentages(defaultPercentages);
  };


  function totalAssignment_visit(assessment_visit, scale) {
    const total = parseInt(assessment_visit?.list_1)+parseInt(assessment_visit?.list_2)+parseInt(assessment_visit?.list_3)+parseInt(assessment_visit?.list_4)+parseInt(assessment_visit?.list_5)+parseInt(assessment_visit?.list_6)
    +parseInt(assessment_visit?.list_7)+parseInt(assessment_visit?.list_8)+parseInt(assessment_visit?.list_9)+parseInt(assessment_visit?.list_10)+
    parseInt(assessment_visit?.list_11)+parseInt(assessment_visit?.list_12);
    return scale == 1 ? total * percentages.assessment_visit / 60 : total;
  }

  function totalAssignment_present(assessment_present, scale) {
    const total = parseInt(assessment_present?.list_1)+parseInt(assessment_present?.list_2)+parseInt(assessment_present?.list_3)+parseInt(assessment_present?.list_4)+parseInt(assessment_present?.list_5)+parseInt(assessment_present?.list_6)+
    parseInt(assessment_present?.list_7)+parseInt(assessment_present?.list_8);
    return scale == 1 ? total * percentages.assessment_present/ 40 : total;
  }

function averageScoreLogbook(doclogbook) {
  // Filter out entries with a score of 0 and convert scores to integers
  const filteredScores = doclogbook
    .map((item) => parseInt(item?.mark, 10))
    .filter((mark) => mark > 0);

  if (filteredScores.length === 0) return 0; // Return 0 if no non-zero entries

  // Calculate total of filtered scores
  const total = filteredScores.reduce((a, b) => a + b, 0);

  // Calculate and return average of non-zero scores, rounded to 1 decimal place
  return parseFloat((total/ filteredScores.length * percentages.logbook/5).toFixed(1));
}

  const [rowsData, setRowsData] = useState([]);
  const [excelDataSet, setExcelDataSet] = useState([]);
  const isMobile = useMediaQuery('(max-width:767px)');


  const onHandleItems = (items) => {
   // console.log("onHandleItems", items);

    const rows = items.map((row) => {
      let dataJson;
      
      if (row.internLocation) {
        dataJson = JSON.parse(row?.internLocation?.manual_data);
      }



      return {
        req_id: row?.req_id,
        st_id: row?.st_id,
        name: `${row?.internStudent?.name}, ${matchOptions(
          optionsBranch,
          row?.internStudent?.b_id
        )}`,
        company: row?.company?.name,
        address: `${row.company.address} ${row.company.subdistrict}${row.company.district} ${row.company.province} ${row.company.zip}`,
        type_internship: matchOptions(internType, row.type_internship),
        intern_period: `${row.start_date} ถึง ${row.end_date}`,
        status: new Date(row?.start_date).getTime(),
        supervisor: row.supervisor,

        updated_at: "",
        form: row?.internLocation?.date_updated ?? "",
        internLocation_created: row?.internLocation?.date_created ?? "",
        start_date: row.start_date,
        end_date: row.end_date,
        b_id: row?.internStudent?.b_id,

        addressIntern: dataJson
          ? `${dataJson?.company.address.no} ${
              dataJson?.company.address.province.includes("กรุงเทพ")
                ? "แขวง"
                : "ต."
            }` +
            `${dataJson?.company.address.sub_district} ${
              dataJson?.company.address.province.includes("กรุงเทพ")
                ? "เขต"
                : "อ."
            }` +
            `${dataJson?.company.address.district} ${
              dataJson?.company.address.province.includes("กรุงเทพ")
                ? " "
                : "จ."
            }${dataJson?.company.address.province}` +
            ` ${dataJson?.company.address.postcode}`
          : `${row.company.address} ${
              row.company.province.includes("กรุงเทพ") ? "แขวง" : "ต."
            }` +
            `${row.company.subdistrict} ${
              row.company.province.includes("กรุงเทพ") ? "เขต" : "อ."
            }${row.company.district}` +
            ` ${row.company.province.includes("กรุงเทพ") ? "" : "จ."}${
              row.company.province
            } ${row.company.zip}`,

        addressUrl: dataJson?.location.link ?? "",

        auditorName: dataJson?.auditor.name ?? "",
        auditorPosition: dataJson?.auditor.position ?? "",
        auditorDepartment: dataJson?.auditor.department ?? "",
        auditorEmail: dataJson?.auditor.fax ?? "",
        auditorTel: dataJson?.auditor.tel ?? "",

        hrName: dataJson?.person.name ?? "",
        hrPosition: dataJson?.person.position ?? "",
        hrDepartment: dataJson?.person.department ?? "",
        hrEmail: dataJson?.person.email ?? "",
        hrTel: dataJson?.person.tel ?? "",

        jobDescription: dataJson?.job.desc ?? "",
        jobPosition: dataJson?.job.position ?? "",

        logbooklist: row?.doclogbook ?? "",
        logbookscore: averageScoreLogbook(row?.doclogbook),

        internReport: row?.internReport,
        internDetailMark: row?.internLocation?.mark * percentages.intern_location /5 ?? "",
        assessment_visit: row?.assessment_visit,
        totalAssignment_visit: totalAssignment_visit(row?.assessment_visit,1),
        assessment_present: row?.assessment_report,
        totalAssignment_present: totalAssignment_present(row?.assessment_report,1),
        assessment_company: row?.assessment_company,
        assessment_company_total: row?.assessment_company.total_score *percentages.assessment_supervisor ?? "",

       

        
    
        

      };
    });

    //const sortData = rows.sort((a, b) => (a.st_id > b.st_id ? 1 : -1));

    const sortData = rows.sort((a, b) => (a.company > b.company ? 1 : -1));

    return sortData;
  };

  const onHandleExcel = (dataArr = []) => {
    const excelData = dataArr
      .filter((item) => {
        const itemStartDate = new Date(item.start_date).getTime();
        const twoMonthsAfterStart = new Date(item.start_date).getTime() + (60 * 24 * 60 * 60 * 1000); // 60 วัน
        const currentDate = new Date().getTime();
        
        if (dateRange.startDate && dateRange.endDate) {
          // ถ้าผู้ใช้เลือกช่วงวันที่ - กรองตามช่วงที่เลือก
          const selectedStartDate = new Date(dateRange.startDate).getTime();
          const selectedEndDate = new Date(dateRange.endDate).getTime();
          
          // แสดงคนที่ครบ 2 เดือนในช่วงที่เลือก
          return twoMonthsAfterStart >= selectedStartDate && twoMonthsAfterStart <= selectedEndDate;
        }
        
        // ค่าเริ่มต้น: แสดงคนที่ควรประเมิน 2 เดือนแล้ว (ครบ 2 เดือน ± 1.5 เดือน)
        const bufferTime = 45 * 24 * 60 * 60 * 1000; // 45 วัน (1.5 เดือน)
        const earliestEvaluationDate = twoMonthsAfterStart - bufferTime;
        const latestEvaluationDate = twoMonthsAfterStart + bufferTime;
        
        return currentDate >= earliestEvaluationDate && currentDate <= latestEvaluationDate;
      }).map((row) => {
        // console.log("row", row);
        return {
          
          req_id: row?.req_id,
          st_id: row?.st_id,
          name: row?.name.split(", ")[0],
          branch: row?.name.split(", ")[1],
          company: row?.company,
          address: row?.address,
          province: row?.company.province,
          //`${row.company.address} ${row.company.subdistrict} ${row.company.district} ${row.company.province} ${row.company.zip}`,
          type_internship: row?.type_internship,
          intern_period: `${row?.start_date} ถึง ${row?.end_date}`,
          form: row?.form,

          addressIntern: row?.addressIntern,
          addressUrl: row?.addressUrl,

          auditorName: row?.auditorName,
          auditorPosition: row?.auditorPosition,
          auditorDepartment: row?.auditorDepartment,
          auditorEmail: row?.auditorEmail,
          auditorTel: row?.auditorTel,

          hrName: row?.hrName,
          hrPosition: row?.hrPosition,
          hrDepartment: row?.hrDepartment,
          hrEmail: row?.hrEmail,
          hrTel: row?.hrTel,

          jobDescription: row?.jobDescription,
          jobPosition: row?.jobPosition,
          internDetailMark: parseInt(row?.internDetailMark),
          

          logbook1: row?.logbooklist[0]?.link,

          logbookscore: averageScoreLogbook(row?.logbooklist),
          totalAssignment_visit: totalAssignment_visit(row?.assessment_visit,1),
          totalAssignment_present: totalAssignment_present(row?.assessment_present,1),
          assessment_company: row?.assessment_company *percentages.assessment_supervisor/85 ?? "",

          total: averageScoreLogbook(row?.logbooklist) +
          totalAssignment_visit(row?.assessment_visit,1)+
          totalAssignment_present(row?.assessment_present,1)+
          parseInt(row?.internDetailMark)+
          parseFloat(row?.assessment_company?.total)*percentages.assessment_supervisor/30,


        };
      });
      
    setExcelDataSet(excelData.sort((a, b) => (a.company > b.company ? 1 : -1)));
    console.log("excelData", excelData);
  };




  const [dateRange, setDateRange] = useState({
    startDate: '',
    endDate: ''
  });

  const handleDateChange = (event) => {
    setDateRange({
      ...dateRange,
      [event.target.name]: event.target.value
    });
  };

  const handleResetDates = () => {
    setDateRange({
      startDate: '',
      endDate: ''
    });
  };

  const getCurrentDate = () => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const dd = String(today.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  };

  const currentDate = getCurrentDate();
  


  useEffect(() => {
    if (items.length) {
      //console.log("useEffect", items);
      const handleItem = onHandleItems(items);
      setRowsData(handleItem);
      onHandleExcel(handleItem);
    }
  }, [items]);

  useEffect(() => {
    // Recalculate table data when percentages change
    if (items.length) {
      const handleItem = onHandleItems(items);
      setRowsData(handleItem);
      onHandleExcel(handleItem);
    }
  }, [percentages]);

  useEffect(() => {
    // Recalculate table data when date range changes
    if (items.length) {
      const handleItem = onHandleItems(items);
      setRowsData(handleItem);
      onHandleExcel(handleItem);
    }
  }, [dateRange]);




  const headCells = [
    {
      id: "order",
      numeric: true,
      disablePadding: false,
      label: "#",
    },

    {
      id: "req_id",
      numeric: true,
      disablePadding: false,
      label: "Request ID	",
    },

    {
      id: "name",
      numeric: false,
      disablePadding: false,
      label: "ชื่อ - สกุล	",
    },

    // {
    //   id: "company",
    //   numeric: false,
    //   disablePadding: false,
    //   label: "สถานประกอบการ",
    // },
    {
      id: "supervisor",
      numeric: false,
      disablePadding: false,
      label: "อาจารย์นิเทศ",
    },

    {
      id: "intern_location",
      numeric: true,
      disablePadding: false,
      label: <>แจ้งที่ตั้ง
      <br />({percentages.intern_location}%)
      </>,
    },
    {
      id: "logbook",
      numeric: true,
      disablePadding: false,
      label: <>Logbook
      <br />({percentages.logbook}%)
      </>,
    },
    {
      id: "assessment_visit",
      numeric: true,
      disablePadding: false,
      label: <>อ.นิเทศ
      <br />({percentages.assessment_visit}%)
      </>,
    },
    {
      id: "assessment_present",
      numeric: true,
      disablePadding: false,
      label: <>รายงาน
      <br />({percentages.assessment_present}%)
      </>,
    },
    {
      id: "assessment_supervisor",
      numeric: true,
      disablePadding: false,
      label: <>พี่เลี้ยง
      <br />({percentages.assessment_supervisor}%)
      </>,
    },
    {
      id: "total",
      numeric: true,
      disablePadding: false,
      label: <>รวม
        <br />({Object.values(percentages).reduce((acc, curr) => acc + Number(curr), 0)}%)

      </>,
    },
   
  ];

  return (
    <>
      <Box 
        mb={2} 
        mt={2} 
        display="flex" 
        gap={1} 
        alignItems="start"
        sx={{
          background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
          borderRadius: '12px',
          padding: '16px',
          border: '1px solid #e9ecef',
          boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
        }}
      >
        <Box display="flex" gap={1} alignItems="center" flexWrap="wrap">
          <Typography 
            variant="body2" 
            sx={{ 
              fontWeight: 600,
              color: '#495057',
              fontFamily: 'TH Sarabun New, Arial, sans-serif',
              fontSize: '16px',
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              mr: 2,
              minWidth: 'max-content'
            }}
          >
            📊 กรองตามช่วงเวลาประเมิน 2 เดือน:
          </Typography>
          
          <TextField
            type="date"
            name="startDate"
            label="วันที่ครบ 2 เดือนเริ่มต้น"
            value={dateRange.startDate}
            onChange={handleDateChange}
            InputLabelProps={{ shrink: true }}
            size="small"
            sx={{ 
              minWidth: '150px',
              '& .MuiInputBase-input': { py: 0.75 },
              '& .MuiOutlinedInput-root': {
                backgroundColor: 'white',
                '&:hover': { borderColor: '#6b7a8a' },
                '&.Mui-focused': { borderColor: '#5a6a7a' }
              }
            }}
          />
          <TextField
            type="date"
            name="endDate"
            label="วันที่ครบ 2 เดือนสิ้นสุด"
            value={dateRange.endDate}
            onChange={handleDateChange}
            InputLabelProps={{ shrink: true }}
            size="small"
            sx={{ 
              minWidth: '150px',
              '& .MuiInputBase-input': { py: 0.75 },
              '& .MuiOutlinedInput-root': {
                backgroundColor: 'white',
                '&:hover': { borderColor: '#6b7a8a' },
                '&.Mui-focused': { borderColor: '#5a6a7a' }
              }
            }}
          />
          <Tooltip title="รีเซ็ตวันที่กลับค่าเริ่มต้น">
            <IconButton
              onClick={handleResetDates}
              size="small"
              sx={{ 
                ml: 1,
                backgroundColor: 'rgba(107, 122, 138, 0.1)',
                color: '#6b7a8a',
                '&:hover': { 
                  backgroundColor: 'rgba(107, 122, 138, 0.2)',
                  color: '#5a6a7a'
                }
              }}
            >
              <RestartAltIcon />
            </IconButton>
          </Tooltip>
        </Box>
        <Box 
          flexGrow={1} 
          display="flex" 
          justifyContent="flex-end"
          alignItems="center"
        >
          <Box
            sx={{
              background: 'linear-gradient(135deg, #6b7a8a 0%, #5a6a7a 100%)',
              borderRadius: '12px',
              padding: '10px 18px',
              border: '1px solid rgba(255,255,255,0.2)',
              boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
              display: 'flex',
              alignItems: 'center',
              gap: 1
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', fontSize: '16px' }}>📅</Box>
            <Typography 
              variant="body2" 
              sx={{ 
                color: 'rgba(255, 255, 255, 0.95)',
                fontFamily: 'TH Sarabun New, Arial, sans-serif',
                fontWeight: 600,
                fontSize: '15px',
                letterSpacing: '0.3px'
              }}
            >
              ช่วงเวลาประเมิน: {dateRange.startDate || 'ครบ 2 เดือน ± 1.5 เดือน'} - {dateRange.endDate || 'อัตโนมัติ'}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box 
        mb={3} 
        mt={2} 
        display="flex" 
        gap={1} 
        alignItems="center"
        sx={{
          background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
          borderRadius: '12px',
          padding: '16px',
          border: '1px solid #dee2e6',
          boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
          <Typography 
            variant="body2" 
            sx={{ 
              fontWeight: 600,
              color: '#495057',
              fontFamily: 'TH Sarabun New, Arial, sans-serif',
              fontSize: '16px',
              display: 'flex',
              alignItems: 'center',
              gap: 1
            }}
          >
            การตั้งค่า % การประเมิน:
          </Typography>
        </Box>
        
        <TextField
          type="number"
          name="intern_location"
          label="แจ้งที่ตั้ง (%)"
          value={percentages.intern_location}
          onChange={handlePercentageChange}
          InputLabelProps={{ shrink: true }}
          size="small"
          sx={{ 
            minWidth: '70px',
            maxWidth: '90px',
            '& .MuiInputBase-input': { py: 0.75, textAlign: 'center' },
            '& .MuiOutlinedInput-root': {
              backgroundColor: 'white',
              '&:hover': { borderColor: '#6b7a8a' },
              '&.Mui-focused': { borderColor: '#5a6a7a' }
            }
          }}
        />
        <TextField
          type="number"
          name="logbook"
          label="Logbook (%)"
          value={percentages.logbook}
          onChange={handlePercentageChange}
          InputLabelProps={{ shrink: true }}
          size="small"
          sx={{ 
            minWidth: '70px',
            maxWidth: '90px',
            '& .MuiInputBase-input': { py: 0.75, textAlign: 'center' },
            '& .MuiOutlinedInput-root': {
              backgroundColor: 'white',
              '&:hover': { borderColor: '#6b7a8a' },
              '&.Mui-focused': { borderColor: '#5a6a7a' }
            }
          }}
        />
        <TextField
          type="number"
          name="assessment_visit"
          label="อ.นิเทศ (%)"
          value={percentages.assessment_visit}
          onChange={handlePercentageChange}
          InputLabelProps={{ shrink: true }}
          size="small"
          sx={{ 
            minWidth: '70px',
            maxWidth: '90px',
            '& .MuiInputBase-input': { py: 0.75, textAlign: 'center' },
            '& .MuiOutlinedInput-root': {
              backgroundColor: 'white',
              '&:hover': { borderColor: '#6b7a8a' },
              '&.Mui-focused': { borderColor: '#5a6a7a' }
            }
          }}
        />
        <TextField
          type="number"
          name="assessment_present"
          label="รายงาน (%)"
          value={percentages.assessment_present}
          onChange={handlePercentageChange}
          InputLabelProps={{ shrink: true }}
          size="small"
          sx={{ 
            minWidth: '70px',
            maxWidth: '90px',
            '& .MuiInputBase-input': { py: 0.75, textAlign: 'center' },
            '& .MuiOutlinedInput-root': {
              backgroundColor: 'white',
              '&:hover': { borderColor: '#6b7a8a' },
              '&.Mui-focused': { borderColor: '#5a6a7a' }
            }
          }}
        />
        <TextField
          type="number"
          name="assessment_supervisor"
          label="พี่เลี้ยง (%)"
          value={percentages.assessment_supervisor}
          onChange={handlePercentageChange}
          InputLabelProps={{ shrink: true }}
          size="small"
          sx={{ 
            minWidth: '70px',
            maxWidth: '90px',
            '& .MuiInputBase-input': { py: 0.75, textAlign: 'center' },
            '& .MuiOutlinedInput-root': {
              backgroundColor: 'white',
              '&:hover': { borderColor: '#6b7a8a' },
              '&.Mui-focused': { borderColor: '#5a6a7a' }
            }
          }}
        />

        <Tooltip title="รีเซ็ตเปอร์เซ็นต์กลับค่าเริ่มต้น">
          <IconButton
            onClick={handleResetPercentages}
            size="small"
            sx={{ 
              ml: 1,
              backgroundColor: 'rgba(107, 122, 138, 0.1)',
              color: '#6b7a8a',
              '&:hover': { 
                backgroundColor: 'rgba(107, 122, 138, 0.2)',
                color: '#5a6a7a'
              }
            }}
          >
            <RestartAltIcon />
          </IconButton>
        </Tooltip>
      </Box>

      <InternEvaluationTable
        textActive={textActive}
        tableColumn={headCells}
        tableData={rowsData.filter((item) => {
          const itemStartDate = new Date(item.start_date).getTime();
          const twoMonthsAfterStart = new Date(item.start_date).getTime() + (60 * 24 * 60 * 60 * 1000); // 60 วัน
          const currentDate = new Date().getTime();
          
          if (dateRange.startDate && dateRange.endDate) {
            // ถ้าผู้ใช้เลือกช่วงวันที่ - กรองตามช่วงที่เลือก
            const selectedStartDate = new Date(dateRange.startDate).getTime();
            const selectedEndDate = new Date(dateRange.endDate).getTime();
            
            // แสดงคนที่ครบ 2 เดือนในช่วงที่เลือก
            return twoMonthsAfterStart >= selectedStartDate && twoMonthsAfterStart <= selectedEndDate;
          }
          
          // ค่าเริ่มต้น: แสดงคนที่ควรประเมิน 2 เดือนแล้ว (ครบ 2 เดือน ± 1.5 เดือน)
          const bufferTime = 45 * 24 * 60 * 60 * 1000; // 45 วัน (1.5 เดือน)
          const earliestEvaluationDate = twoMonthsAfterStart - bufferTime;
          const latestEvaluationDate = twoMonthsAfterStart + bufferTime;
          
          return currentDate >= earliestEvaluationDate && currentDate <= latestEvaluationDate;
        })}

        allStaff={allStaff}
        excelDataSet={excelDataSet}
        percentages={percentages}
        onRefresh={onRefresh} // ส่ง callback สำหรับ refresh ข้อมูล

      />
    </>
  );
};

export default DashboardInternshipTab;

/*
   * ระบบกรองข้อมูลสำหรับการประเมินฝึกงาน 2 เดือน
   * - รองรับทั้งการฝึกงาน 2 เดือน และ 6 เดือน
   * - ประเมินที่ 2 เดือนหลังเริ่มฝึกงาน
   * - ค่าเริ่มต้น: แสดงคนที่ครบ 2 เดือน ± 1.5 เดือน (buffer time)
   * - เมื่อเลือกช่วงวันที่: กรองตามวันที่ครบ 2 เดือนที่อยู่ในช่วงที่เลือก
   */